"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rafListesiSchema = exports.rafBelgesiSchema = exports.rafListeSuzgeciSchema = exports.dokumanYukleSchema = exports.DOKUMAN_DOSYA_TURLERI = exports.kontrolluBelgeYapisiSchema = exports.KONTROLLU_BELGE_YAPILARI = exports.RAF_SEKME_ETIKETI = exports.rafSekmesiSchema = exports.DOKUMAN_RAF_SEKMELERI = void 0;
exports.dokumanDosyaTuruKabulMu = dokumanDosyaTuruKabulMu;
const zod_1 = require("zod");
const kontrollu_belge_1 = require("./kontrollu-belge");
/**
 * DOKÜMAN YÖNETİMİ — V1 SADE RAF (Kapsam §31, K1-K6 + D9; ERD §10k —
 * 07.09.2026; sertleştirme programı sonrası BEŞİNCİ ve SON yapım turu).
 *
 * ════════════════════════════════════════════════════════════════════════
 * RAF, KONTROLLÜ BELGE ÇEKİRDEĞİNİN İKİNCİ MÜŞTERİSİDİR
 * ════════════════════════════════════════════════════════════════════════
 *
 * Altı sekme (K1), altlarında şirketin yüklediği PDF'ler; kayıt başına ad
 * (= dosya adı) · dosya · yükleyen · yükleme tarihi — BU KADAR. Bu sözleşme
 * bilinçli olarak şunları TAŞIMAZ (kanarya `dokuman-yuklem-envanteri.spec`):
 *   · yasal bağ / periyot / bitiş (K3 — raf tiplerinde harita satırı null;
 *     vadeli takip yasal uygunluk tarafında, kanıt eki PDF),
 *   · hazırlayan · onaylayan · yayın durumu · önceki sürüm (K6 — v2, madde 206).
 *
 * "Form" sekmesi form MOTORU değildir (K4): şirketin kendi doküman
 * sisteminden yayınladığı form PDF'leri. M1: açıklama cümlesi yazılmaz.
 */
exports.DOKUMAN_RAF_SEKMELERI = kontrollu_belge_1.DOKUMAN_RAF_TIPLERI;
exports.rafSekmesiSchema = zod_1.z.enum(exports.DOKUMAN_RAF_SEKMELERI);
exports.RAF_SEKME_ETIKETI = {
    plan: 'Plan',
    politika: 'Politika',
    prosedur: 'Prosedür',
    talimat: 'Talimat',
    form: 'Form',
    sema: 'Şema',
    diger: 'Diğer',
    // Sekme kısa adla; tipin görünen adı `KONTROLLU_BELGE_TIP_ETIKETI.gbf` (tam ad).
    gbf: 'GBF',
};
/** Tipin YAPISI — tekil (sürümlü, güncel türetilir) ya da raf (kategori). */
exports.KONTROLLU_BELGE_YAPILARI = ['tekil', 'raf'];
exports.kontrolluBelgeYapisiSchema = zod_1.z.enum(exports.KONTROLLU_BELGE_YAPILARI);
/**
 * Kabul edilen dosya türleri — K1 *"şirketin yüklediği PDF'ler"* harfiyen.
 * Tek kaynak: sunucu imza doğrulamasının çıktısını bu listeye vurur;
 * genişletme (şema PNG) ürün kararıdır ve yalnız burayı değiştirir.
 */
exports.DOKUMAN_DOSYA_TURLERI = ['application/pdf'];
function dokumanDosyaTuruKabulMu(mimeType) {
    return exports.DOKUMAN_DOSYA_TURLERI.includes(mimeType);
}
// ── İstek şemaları ────────────────────────────────────────────────────────
/** Multipart alanları düz metin gelir — tip YALNIZ altı raf tipi (acil durum tipi bu uçtan 422). */
exports.dokumanYukleSchema = zod_1.z
    .strictObject({
    tip: zod_1.z.enum(kontrollu_belge_1.DOKUMAN_RAF_TIPLERI),
    workplaceId: zod_1.z.uuid(),
    /**
     * D2-3 (17.09.2026): YALNIZ *Diğer* sekmesinde, zorunlu serbest belge adı.
     * Öteki sekmelerde ad dosya adıdır (K1) — gövdede gelirse 400.
     */
    ad: zod_1.z.string().trim().max(200).optional(),
    /**
     * P2 (01.11.2026): YALNIZ *GBF* sekmesinde — kimyasalın adı (zorunlu) ve
     * tedarikçinin GBF üzerine yazdığı düzenleme tarihi (opsiyonel, ISO gün;
     * dış belgeye ait veri — raf revizyon mekanizması DEĞİL, K6 aynen). Başka
     * sekmede gövdede gelirse 400 (D2-3'ün `ad` kuralının ikizi); boş dizge
     * multipart'ta "verilmedi" sayılır.
     */
    kimyasalAdi: zod_1.z
        .string()
        .trim()
        .max(200)
        .optional()
        .transform((v) => (v === '' ? undefined : v)),
    gbfDuzenlemeTarihi: zod_1.z
        .string()
        .trim()
        .optional()
        .transform((v) => (v === '' ? undefined : v))
        .pipe(zod_1.z.iso.date().optional()),
})
    .superRefine((deger, ctx) => {
    if (deger.tip === 'diger' && !deger.ad) {
        ctx.addIssue({ code: 'custom', path: ['ad'], message: 'Belge adı yazılmalı' });
    }
    if (deger.tip === 'gbf' && !deger.kimyasalAdi) {
        ctx.addIssue({ code: 'custom', path: ['kimyasalAdi'], message: 'Kimyasal adı yazılmalı' });
    }
    if (deger.tip !== 'gbf' &&
        (deger.kimyasalAdi !== undefined || deger.gbfDuzenlemeTarihi !== undefined)) {
        ctx.addIssue({
            code: 'custom',
            path: ['kimyasalAdi'],
            message: 'Kimyasal adı ve GBF düzenleme tarihi yalnız GBF sekmesinde girilir',
        });
    }
    if (deger.tip !== 'diger' && deger.ad !== undefined) {
        ctx.addIssue({
            code: 'custom',
            path: ['ad'],
            message: 'Bu sekmede belgenin adı dosya adıdır',
        });
    }
});
/** Liste süzgeci — tanınmayan değer sessizce "tümü"ye DÜŞMEZ (400; sunucu `safeParse`). */
exports.rafListeSuzgeciSchema = zod_1.z.object({
    sekme: exports.rafSekmesiSchema,
    workplaceId: zod_1.z.uuid().optional(),
    ara: zod_1.z.string().trim().max(120).optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
// ── Yanıt şemaları ────────────────────────────────────────────────────────
/**
 * Raf satırı. `tip` sekiz tipten biri (acil durum belgesi Plan sekmesinde DE
 * görünür — tek kayıt iki yüzey); `yapi` sunucuda haritadan; `silinebilir`
 * SUNUCUDA türetilir (yazma şapkası ∧ bahçe ∧ yapı raf — §2.40).
 */
exports.rafBelgesiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    tip: kontrollu_belge_1.kontrolluBelgeTipiSchema,
    tipEtiketi: zod_1.z.string().min(1),
    sekme: exports.rafSekmesiSchema,
    yapi: exports.kontrolluBelgeYapisiSchema,
    /** = dosya adı (K1); ✏️ D2-3: *Diğer* sekmesinde kullanıcının yazdığı serbest ad. */
    ad: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    yukleyenEtiket: zod_1.z.string().min(1),
    /** `created_at` — yükleme anı. */
    yuklemeTarihi: zod_1.z.iso.datetime(),
    /** P2: yalnız GBF satırında dolu (kimyasal adı zorunlu; düzenleme tarihi ISO gün ya da null). */
    kimyasalAdi: zod_1.z.string().min(1).nullable(),
    gbfDuzenlemeTarihi: zod_1.z.iso.date().nullable(),
    silinebilir: zod_1.z.boolean(),
});
exports.rafListesiSchema = zod_1.z.object({
    sekme: exports.rafSekmesiSchema,
    satirlar: zod_1.z.array(exports.rafBelgesiSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
    yetkiler: zod_1.z.object({
        /** Şapka ∧ en az bir yazılabilir işyeri — E1 tetikleyicisinin görünürlüğü. */
        yazabilir: zod_1.z.boolean(),
    }),
    /** Yükleme satırının işyeri listesi — şapka ∧ tam kapsama ∧ aktif (sunucuda). */
    yuklenebilirIsyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
});
//# sourceMappingURL=dokuman.js.map